var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdenes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Editar-producto",
    transform: "translate(-38.000000, -131.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(38.000000, 131.200010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0.75,
    y: 0.75,
    width: 7.807692,
    height: 7.807688
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 13.442383,
    y: 0.75,
    width: 7.8076935,
    height: 7.807688
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0.75,
    y: 13.442322,
    width: 7.807692,
    height: 7.807689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 13.442383,
    y: 13.442322,
    width: 7.8076935,
    height: 7.807689
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdenes);
export default __webpack_public_path__ + "static/media/ordenes.fd5af109992a78462fe5d7f5d18d3c63.svg";
export { ForwardRef as ReactComponent };